import { useState } from 'react';
import { AOTV_LOGO, AOTV_LOGO_FALLBACK } from '../lib/theme';

/**
 * AOTV wordmark/logo with automatic fallback to the legacy AWS-hosted
 * asset if the local /brand/logo-colour.png hasn't been committed yet.
 * Drop-in replacement for `<img src={AOTV_LOGO} />`.
 */
export function AotvLogo({
  alt = 'AOTV Logo',
  ...rest
}: React.ImgHTMLAttributes<HTMLImageElement>) {
  const [src, setSrc] = useState(AOTV_LOGO);
  return (
    <img
      src={src}
      alt={alt}
      onError={() => {
        if (src !== AOTV_LOGO_FALLBACK) setSrc(AOTV_LOGO_FALLBACK);
      }}
      {...rest}
    />
  );
}
